export interface ICountry {
  id: string
  code: string | null
  currency: string | null
  name: string
  native: string
  parent: string | null
  phone: string | null
  postalCode: string | null
  type?: string
}

export interface IProvince extends ICountry {
  country_id: string
}
export interface IDistrict extends ICountry {
  province_id: string
}
export interface ISubDistrict extends IDistrict {
  district_id: string
  postalCode: string
}

export type IAddress = ICountry[] | IProvince[] | IDistrict[] | ISubDistrict[]

export enum AddressPath {
  COUNTRIES = 'countries',
  PROVINCES = 'provinces',
  DISTRICTS = 'districts',
  SUB_DISTRICTS = 'subDistricts',
}
